import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { AppRoleType } from '@/utils/permission';

const planSettingRoutes: RouteConfig = {
  path: '/plansetting',
  component: Layout,
  redirect: '/plansetting/list',
  meta: {
    title: 'Plan setting',
    icon: 'mdi-clipboard-text-outline',
    alwaysShow: true,
    roles: [AppRoleType.ADMIN, AppRoleType.PLAN_SETTING_EDITOR],
  },
  children: [
    {
      path: 'list',
      component: () =>
        import(
          /* webpackChunkName: "plansetting" */ '@/views/plansetting/list/index.vue'
        ),
      name: 'plansetting-list',
      meta: {
        title: 'Plan setting list',
        icon: 'mdi-clipboard-list-outline',
        roles: [AppRoleType.ADMIN, AppRoleType.PLAN_SETTING_EDITOR],
      },
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "plansetting" */ '@/views/plansetting/create/index.vue'
        ),
      name: 'plansetting-create',
      meta: {
        title: 'Plan setting create',
        icon: 'mdi-clipboard-plus',
        roles: [AppRoleType.ADMIN, AppRoleType.PLAN_SETTING_EDITOR],
      },
    },
    {
      path: ':id',
      component: () =>
        import(
          /* webpackChunkName: "plansetting" */ '@/views/plansetting/detail/index.vue'
        ),
      name: 'plansetting-detail',
      meta: {
        title: 'Plan setting detail',
        icon: 'mdi-clipboard-text-play-outline',
        hidden: true,
        roles: [AppRoleType.ADMIN, AppRoleType.PLAN_SETTING_EDITOR],
      },
      props: route => ({
        id: route.params.id,
      }),
    },
  ],
};

export default planSettingRoutes;
